/* eslint-disable
    no-undef,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import DefaultEmbedConstants from 'constants/DefaultEmbedConstants'
import OrgPropertiesConstants from 'constants/OrgPropertiesConstants'
import { captureException, captureResponseException } from 'utils/SentryHelpers'
import { patchOperations } from 'utils/PatchHelper'

const OrgPropertiesQueries = Marty.createQueries({
  id: 'OrgPropertiesQueries',

  fetchProperties(orgId) {
    const promise = this.app.sources.OrgPropertiesAPI.fetchProperties(orgId)
    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(OrgPropertiesConstants.FETCH_ORG_PROPERTIES_DONE, orgId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(OrgPropertiesConstants.FETCH_ORG_PROPERTIES_FAILED, res)
      }
    })
    return promise.catch(error => {
      captureException(error)
      return this.dispatch(OrgPropertiesConstants.FETCH_ORG_PROPERTIES_FAILED, error)
    })
  },

  updateProperties(orgId, properties, notificationMessage) {
    const promise = this.app.sources.OrgPropertiesAPI.updateProperties(orgId, properties)
    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(OrgPropertiesConstants.UPDATE_ORG_PROPERTIES_DONE, orgId, res.body, properties)
        if (notificationMessage) {
          return this.app.actions.NotificationActions.pushNotification({
            content: notificationMessage
          })
        }
      } else {
        captureResponseException(res)
        return this.dispatch(OrgPropertiesConstants.UPDATE_ORG_PROPERTIES_FAILED, orgId, properties, res)
      }
    })
    return promise.catch(error => {
      captureException(error)
      return this.dispatch(OrgPropertiesConstants.UPDATE_ORG_PROPERTIES_FAILED, orgId, properties, error)
    })
  },

  uploadOrgLogo(orgId, file, fileId, updateOrg) {
    this.dispatch(OrgPropertiesConstants.UPLOAD_ORG_LOGO_STARTING, orgId, file, fileId)
    const orgLogoUploadPromise =
      this.app.sources.OrgPropertiesAPI.uploadOrgImage(orgId, file)
    orgLogoUploadPromise.then(res => {
      if (res.status === 200) {
        const logoUrl = res.body.attachmentUrl
        const update = { theme: { logoUrl }}
        const operations = patchOperations(update, {})
        const promise = this.app.sources.DefaultEmbedAPI.patchDefaultEmbed(operations)
        return promise.then(res => {
          if (res.status === 200) {
            this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_PATCH_DONE, res.body)
            this.dispatch(OrgPropertiesConstants.UPLOAD_ORG_LOGO_DONE, orgId, logoUrl, fileId)
            return this.app.actions.NotificationActions.pushNotification({
              content: 'Your organization logo has been updated'
            })
          } else {
            captureResponseException(res)
            this.dispatch(DefaultEmbedConstants.DEFAULT_EMBED_PATCH_FAILED, operations, res)
            throw new Error('Failed to update logo url')
          }
        })
      } else {
        throw new Error('Failed to update logo url', res)
      }
    })
    return orgLogoUploadPromise.catch(error => {
      captureException(error)
      return this.dispatch(OrgPropertiesConstants.UPLOAD_ORG_LOGO_FAILED, orgId, error, fileId)
    })
  },

  /**
   * uploadOrgImage
   * Uploads an image associated with an organization.
   * @param { number } orgId - the organization's ID
   * @param { File } file - File to upload
   * @param { String } imageType - String to identify this org image type (e.g. welcome-image)
   */
  uploadOrgImage(orgId, file, imageType) {
    this.dispatch(OrgPropertiesConstants.UPLOAD_ORG_IMAGE_STARTING, orgId, file, imageType)
    const orgLogoUploadPromise =
      this.app.sources.OrgPropertiesAPI.uploadOrgImage(orgId, file)
    orgLogoUploadPromise.catch(error => {
      captureException(error)
      return this.dispatch(OrgPropertiesConstants.UPLOAD_ORG_IMAGE_FAILED, orgId, error, imageType)
    })
    return orgLogoUploadPromise.then(res => {
      if (res.status === 200) {
        return this.dispatch(OrgPropertiesConstants.UPLOAD_ORG_IMAGE_DONE, orgId, res.body.attachmentUrl, imageType)
      } else {
        captureResponseException(res)
        return this.dispatch(OrgPropertiesConstants.UPLOAD_ORG_IMAGE_FAILED, orgId, error, imageType)
      }
    })
  }
})

export default OrgPropertiesQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/OrgPropertiesQueries.js